/*
$( document ).ready(function() {
 var menu = '';
 menu += '<div class="gameday-menu">';
 menu += '<div class="gameday-left">';
 menu += '<a href="/" class="gameday-btn">WEITER ZUR WEBSEITE</a>';
 menu += '</div>';
 menu += '<div class="gameday-right">';
 menu += '<h1 class="main-page-title page-title h0">MATCHTAG</h1>'; 
 menu += '</div>';
 menu += '</div>';
 $('.website-header .megamenu_wrapper .megamenu_inner .megamenu_left').html(menu); 
 $('.website-header header.header header-drawer').hide();
 

});

resizeWindow();
$(window).resize(function(){
  resizeWindow();
});

function resizeWindow(){
  if($(window).width() < 993){
     var menu = '';
     menu += '<div class="gameday-menu">';
     menu += '<div class="gameday-left">';
     menu += '<a href="/" class="gameday-btn">WEITER ZUR WEBSEITE</a>';
     menu += '</div>';
     menu += '<div class="gameday-right">';
     menu += '<h1 class="main-page-title page-title h0">MATCHTAG</h1>'; 
     menu += '</div>';
     menu += '</div>';
    $(menu).insertAfter(".website-header header.header .header__heading-link");
  }else{
    $('.website-header header.header .gameday-menu').hide();
  }
}
*/

var load_news_first = false;
$(window).scroll(function(event) {
if(load_news_first == false) {
  // NEWS
  var newsURL = CDN_URL+"news?page[number]=1&page[size]=4&sort=-publishDate&&filter[isActive]=1&filter[newsCategoryId]=17283";

  var settingsData = {
    "url": newsURL,
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Accept": "application/vnd.api+json"
    }
  };

  $.ajax(settingsData).done(function (response) {

  $('.gameday-news-wrapper .gdn_preloader').fadeOut();
  $('.gameday-news-wrapper .gdn_status').fadeOut('slow');

  var totalData = response.data.length;
  var html = "";
  html += '<div class="grid grid--2-col-desktop grid--2-col-tablet-down">';

      for(var a=0; a<totalData; a++){
        var json_response = response.data[a].attributes;
        var imagesrc = '';
        var title = jQuery.trim(json_response.name);
        var description = '';

        if(json_response.excerpt != null){
          description = json_response.excerpt;
        }else {
          description = '';
        }
          
       if(json_response.optimizedListImage != null){
          imagesrc = json_response.optimizedListImage;
        }else if(json_response.optimizedImage != null){
          imagesrc = json_response.optimizedImage;
        }else if(json_response.image != null){
          imagesrc = json_response.image;
        }else{
          imagesrc = 'https://cdn.shopify.com/s/files/1/0565/2201/4813/files/news-blank-image.png';
        }

        var focusXPercentage = "";
        if(json_response.focusXPercentage != null && json_response.focusXPercentage > 0 && json_response.focusXPercentage <= 100){
          focusXPercentage = json_response.focusXPercentage+'%';
        }else {
          focusXPercentage = 'top';
        }

        var focusYPercentage = "";
        if(json_response.focusYPercentage != null && json_response.focusYPercentage > 0 && json_response.focusYPercentage <= 100){
          focusYPercentage = json_response.focusYPercentage+'%';
        }else {
          focusYPercentage = 'center';
        }
        
        var newscat = '';
        if(json_response.newsCategory !== null ){

          for(var nc=0; nc <json_response.newsCategory.translations.length; nc++){
              newscat += ' '+json_response.newsCategory.translations[nc].webName;
          }
        }
        
        var url=response.data[a].id;
        if(response.data[a].attributes.urlHandle != null){
          var url = response.data[a].attributes.urlHandle;
        }

          html += '<div class="grid__item'+newscat+'">';
              html += '<div class="news-wrapper">';
                  html += '<div class="image-wrapper">';
                      html += '<img src="'+imagesrc+'" width="320" loading="lazy" style="object-position: '+focusXPercentage+' '+focusYPercentage+'">';
                  html += '</div>';
                  html += '<div class="content-wrapper">';
                      html += '<div class="newsblock__date">'+formatDateString(response.data[a].attributes.publishDate,'regular','false')+'</div>';
                      html += '<h3 class="newsblock__title">'+title+'</h3>';
                      html += '<div class="newsblock__details">'+description+'</div>';
                  html += '</div>';
                  html += '<div class="link-wrapper">';
                      html +='<a href="/pages/news/'+url+'" class="block-btn">';
                          html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 64C256 46.33 270.3 32 288 32H415.1C415.1 32 415.1 32 415.1 32C420.3 32 424.5 32.86 428.2 34.43C431.1 35.98 435.5 38.27 438.6 41.3C438.6 41.35 438.6 41.4 438.7 41.44C444.9 47.66 447.1 55.78 448 63.9C448 63.94 448 63.97 448 64V192C448 209.7 433.7 224 416 224C398.3 224 384 209.7 384 192V141.3L214.6 310.6C202.1 323.1 181.9 323.1 169.4 310.6C156.9 298.1 156.9 277.9 169.4 265.4L338.7 96H288C270.3 96 256 81.67 256 64V64zM0 128C0 92.65 28.65 64 64 64H160C177.7 64 192 78.33 192 96C192 113.7 177.7 128 160 128H64V416H352V320C352 302.3 366.3 288 384 288C401.7 288 416 302.3 416 320V416C416 451.3 387.3 480 352 480H64C28.65 480 0 451.3 0 416V128z"></path></svg>';
                      html += '</a>';
                  html += '</div>';
              html += '</div>';
          html += '</div>';
      }

      html +='</div>';
      
      $('.gameday-news-wrapper #news-container').html(html);

  });

  load_news_first = true;

}
});